import script from "./ModalDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalDetail.vue?vue&type=script&setup=true&lang=js"

import "./ModalDetail.vue?vue&type=style&index=0&id=72b45a7a&lang=scss&scoped=true"

import exportComponent from "C:\\developmentGIT\\Pirca\\PircaSolutions.Forge\\PircaSolutions.Forge.AccessIntegrationSite\\access-integration\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72b45a7a"]])

export default __exports__